export default [
  {
    path: '/zjd/incrementService', // 增值服务
    name: 'incrementService',
    component: () => {
      return import(
        /* webpackChunkName: "incrementservice" */ '@/views/incrementservice'
      )
    }
  },
  {
    path: '/zjd/consultService', // 增值服务-线上问诊咨询
    name: 'consultService',
    component: () => {
      return import(
        /* webpackChunkName: "incrementservice" */ '@/views/incrementservice/consultService.vue'
      )
    }
  },
  {
    path: '/zjd/chooseBaodan', // 选择出险人
    name: 'chooseBaodan',
    component: () => {
      return import(
        /* webpackChunkName: "incrementservice" */ '@/views/incrementservice/chooseBaodan.vue'
      )
    }
  }
]
